import { useState } from "react";
import { motion } from "framer-motion";
import { FORMAT_STYLES } from "@/lib/brand";
import { DayDialog } from "./DayDialog";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const styleFor = (f) => FORMAT_STYLES[f] || FORMAT_STYLES.Post;

export const ContentCalendar = ({ days, weeks }) => {
  const [open, setOpen] = useState(null);
  return (
    <section data-testid="content-calendar" className="px-6 md:px-12 pb-6">
      <div className="bg-white rounded-[32px] border border-[var(--line)] p-4 md:p-8 shadow-[0_24px_60px_-30px_rgba(16,46,36,.35)]">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <h2 className="font-serif-cc text-4xl md:text-5xl">Your 30-day <em>content calendar</em></h2>
          <div className="flex flex-wrap gap-2">
            {Object.values(FORMAT_STYLES).map((s) => (
              <span key={s.label} className="text-xs font-semibold px-3 py-1 rounded-full" style={{ background: s.bg, color: s.fg }}>{s.label}</span>
            ))}
          </div>
        </div>
        <p className="font-hand text-xl text-[var(--muted)] mb-4 no-print">tap any day to see the full idea</p>
        <div className="hidden md:grid grid-cols-7 gap-3 mb-2">
          {WEEKDAYS.map((w) => <p key={w} className="text-xs uppercase tracking-[0.2em] text-[var(--muted)] text-center">{w}</p>)}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-3">
          {days.map((d, i) => {
            const s = styleFor(d.format);
            return (
              <motion.button key={d.day} onClick={() => setOpen(d)} data-testid={`calendar-day-${d.day}`}
                initial={{ opacity: 0, scale: .9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.025 }}
                whileHover={{ y: -4, rotate: i % 2 ? 1.5 : -1.5 }}
                className="text-left rounded-2xl p-3 min-h-[128px] flex flex-col justify-between border border-black/5"
                style={{ background: s.bg, color: s.fg }}>
                <div className="flex justify-between items-start">
                  <span className="font-serif-cc text-3xl leading-none">{d.day}</span>
                  <span className="text-[10px] uppercase font-bold tracking-wider bg-white/60 rounded-full px-2 py-0.5">{d.format}</span>
                </div>
                <p className="text-sm font-semibold leading-snug mt-2">{d.title}</p>
              </motion.button>
            );
          })}
        </div>
        {weeks?.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
            {weeks.map((w, i) => (
              <div key={i} className="rounded-2xl bg-[var(--cream)] p-4">
                <p className="text-xs uppercase tracking-[0.2em] text-[var(--muted)]">Week {i + 1}</p>
                <p className="font-semibold">{w}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <DayDialog day={open} onClose={() => setOpen(null)} />
    </section>
  );
};
